// extracted by mini-css-extract-plugin
export default {"copyToClipboardButton":"copy-to-clipboard__copyToClipboardButton"};